module.exports = __webpack_public_path__ + "static/media/Portrait-10042.50892a59.jpg";